/* DSL Image quality toggle — gebruikt navigator.connection en prefers-reduced-data */
(function(){
  var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var slow = (c && (c.saveData === true || /^(slow-2g|2g|3g)$/.test(c.effectiveType || "")));
  var reducedData = false;
  try { reducedData = window.matchMedia("(prefers-reduced-data: reduce)").matches; } catch(e){}
  if (slow || reducedData) {
    document.documentElement.classList.add("dsl-low-bw");
    // Strip width parameters in image_url-shaped URLs so smaller variants are preferred
    document.querySelectorAll("img[src*=\"width=\"]").forEach(function(img){
      img.src = img.src.replace(/width=\d+/, "width=400");
      if (img.srcset) img.srcset = "";
    });
    if (window.DSL_AB) window.DSL_AB.track("low_bandwidth_mode", {effectiveType: c && c.effectiveType});
  }
})();